/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequestFile } from './APIGuestRequestFile';
import {
    APIGuestRequestFileFromJSON,
    APIGuestRequestFileFromJSONTyped,
    APIGuestRequestFileToJSON,
} from './APIGuestRequestFile';

/**
 * 
 * @export
 * @interface APIPaginatedGuestRequestFileList
 */
export interface APIPaginatedGuestRequestFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedGuestRequestFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestRequestFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestRequestFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIGuestRequestFile>}
     * @memberof APIPaginatedGuestRequestFileList
     */
    results: Array<APIGuestRequestFile>;
}

/**
 * Check if a given object implements the APIPaginatedGuestRequestFileList interface.
 */
export function instanceOfAPIPaginatedGuestRequestFileList(value: object): value is APIPaginatedGuestRequestFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedGuestRequestFileListFromJSON(json: any): APIPaginatedGuestRequestFileList {
    return APIPaginatedGuestRequestFileListFromJSONTyped(json, false);
}

export function APIPaginatedGuestRequestFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedGuestRequestFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIGuestRequestFileFromJSON)),
    };
}

export function APIPaginatedGuestRequestFileListToJSON(value?: APIPaginatedGuestRequestFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIGuestRequestFileToJSON)),
    };
}

